const AdminPageHeader = ({ title, subtitle, controls, actions }) => (
  <header className="page-header admin-page-header">
    <div className="admin-page-heading">
      <h1 className="page-title">{title}</h1>
      {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
    </div>
    {(controls || actions) ? (
      <div className="admin-page-toolbar">
        {controls ? <div className="admin-page-controls">{controls}</div> : null}
        {actions ? <div className="admin-page-actions">{actions}</div> : null}
      </div>
    ) : null}
  </header>
);

export default AdminPageHeader;
